/*
 * TEM 18-Oct-2026 · PU-1 — Subtotal de la ficha (precio por unidad × cantidad).
 * Solo actualiza el texto junto al selector; no toca el carrito ni el checkout.
 * Se actualiza al escribir, con + / −, y al cambiar de variante (evento variant:update
 * de Horizon, o cuando el tema vuelve a dibujar el bloque con otro data-price).
 * Cantidad no válida (vacía, 0, decimales): se oculta la línea del subtotal en vez de inventar un monto.
 */
(() => {
  if (customElements.get('temx-subtotal')) return;

  /** Igual que money_without_trailing_zeros con el formato de la tienda (p. ej. «L {{amount}}»). */
  function formatMoney(cents, format) {
    const fixed = (cents / 100).toFixed(2);
    let [whole, dec] = fixed.split('.');
    const withCommas = (sep) => whole.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
    return (format || '{{amount}}').replace(/{{\s*(\w+)\s*}}/, (_, key) => {
      const trim = dec === '00';
      switch (key) {
        case 'amount_no_decimals':
          return withCommas(',');
        case 'amount_with_comma_separator':
          return withCommas('.') + (trim ? '' : ',' + dec);
        case 'amount_no_decimals_with_comma_separator':
          return withCommas('.');
        default:
          return withCommas(',') + (trim ? '' : '.' + dec);
      }
    });
  }

  class TemxSubtotal extends HTMLElement {
    static get observedAttributes() {
      return ['data-price'];
    }

    connectedCallback() {
      this.root = this.closest('product-form-component') || this.closest('form') || this.parentElement;
      this.onAny = () => requestAnimationFrame(() => this.update());
      this.onVariant = (event) => {
        const v = event?.detail?.resource;
        if (!v || typeof v.price !== 'number') return;
        const id = String(v.id ?? '');
        const ours = this.root?.querySelector('input[name="id"]');
        if (ours && id && ours.value && ours.value !== id) return; // otra ficha en la misma página
        this.dataset.price = String(v.price);
      };
      this.root?.addEventListener('input', this.onAny, true);
      this.root?.addEventListener('change', this.onAny, true);
      this.root?.addEventListener('click', this.onAny, true);
      this.root?.addEventListener('keyup', this.onAny, true);
      document.addEventListener('variant:update', this.onVariant);
      this.update();
    }

    disconnectedCallback() {
      this.root?.removeEventListener('input', this.onAny, true);
      this.root?.removeEventListener('change', this.onAny, true);
      this.root?.removeEventListener('click', this.onAny, true);
      this.root?.removeEventListener('keyup', this.onAny, true);
      document.removeEventListener('variant:update', this.onVariant);
    }

    attributeChangedCallback() {
      if (this.isConnected) this.update();
    }

    update() {
      const price = parseInt(this.dataset.price || '', 10);
      const input = this.root?.querySelector('input[name="quantity"]');
      const unit = this.querySelector('[data-tx-unit]');
      const row = this.querySelector('[data-tx-row]');
      const sub = this.querySelector('[data-tx-sub]');
      const live = this.querySelector('[data-tx-live]');
      if (!Number.isFinite(price) || !unit || !row || !sub) return;
      const format = this.dataset.format;
      unit.textContent = formatMoney(price, format);
      const raw = (input?.value ?? '1').trim();
      const qty = /^\d+$/.test(raw) ? parseInt(raw, 10) : NaN;
      const min = parseInt(input?.min || '1', 10) || 1;
      if (!Number.isFinite(qty) || qty < min) {
        row.hidden = true;
        return;
      }
      row.hidden = false;
      const text = formatMoney(price * qty, format);
      if (sub.textContent !== text) {
        sub.textContent = text;
        if (live) live.textContent = `Subtotal ${text}`;
      }
    }
  }

  customElements.define('temx-subtotal', TemxSubtotal);
})();
